import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";

export function DisplayTab({ settings, updateSetting }) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Layout Settings</CardTitle>
          <CardDescription>Adjust how the app displays on your device</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between p-4 border rounded-lg">
            <div className="space-y-1">
              <Label className="text-base font-medium">Mobile Mode</Label>
              <p className="text-sm text-muted-foreground">Optimized layout for phones with larger buttons, simplified navigation, and stacked views</p>
            </div>
            <Switch checked={settings.mobileMode} onCheckedChange={(checked) => updateSetting('mobileMode', checked)} data-testid="toggle-mobile-mode" />
          </div>
          <div className="flex items-center justify-between p-4 border rounded-lg">
            <div className="space-y-1">
              <Label className="text-base font-medium">Compact Mode</Label>
              <p className="text-sm text-muted-foreground">Reduce spacing and padding to fit more content on screen</p>
            </div>
            <Switch checked={settings.compactMode} onCheckedChange={(checked) => updateSetting('compactMode', checked)} data-testid="toggle-compact-mode" />
          </div>
          <div className="p-4 border rounded-lg bg-muted/50">
            <Label className="text-sm font-medium mb-3 block">Preview</Label>
            <div className={`p-4 border rounded-lg bg-background ${settings.compactMode ? 'space-y-2' : 'space-y-4'}`}>
              <div className={`flex gap-2 ${settings.mobileMode ? 'flex-col' : 'flex-row'}`}>
                <Button size={settings.mobileMode ? "lg" : "default"} style={{ backgroundColor: 'var(--primary-color)' }}>Sample Button</Button>
                <Button size={settings.mobileMode ? "lg" : "default"} variant="outline">Another Button</Button>
              </div>
              <div className={`grid ${settings.mobileMode ? 'grid-cols-1' : 'grid-cols-3'} gap-${settings.compactMode ? '2' : '4'}`}>
                <div className={`p-${settings.compactMode ? '2' : '4'} border rounded bg-muted`}>Card 1</div>
                <div className={`p-${settings.compactMode ? '2' : '4'} border rounded bg-muted`}>Card 2</div>
                <div className={`p-${settings.compactMode ? '2' : '4'} border rounded bg-muted`}>Card 3</div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
